module.exports = __webpack_public_path__ + "img/walletmana.373ed4e7.svg";